import React from "react";
import { makeStyles } from 'tss-react/mui';
import { Button } from "@mui/material";
import { connect } from "react-redux";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { setError } from "../store/features/error/errorSlice";
const mapDispatchToProps = { setError };

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flexBasis: "inherit",
    "& button": {
        textTransform: "none",
        color: theme.palette.text.primary,
        borderColor: theme.palette.divider,
    },
    "& label": {
        cursor: "pointer",
    }
  },
  input: {
    display: "none",
  },
}));


const UploadPhotoButton = (props)=>{
    const { classes } = useStyles();
    const { handlePhoto,setError } = props;
    const fileRef = React.createRef();
    
    const processFile = (file)=>{
      var size = file.size;

      if(size<1000000){
        handlePhoto(file);
      }else{
        setError({
          visible: true,
          type: "error",
          message: "Error: File size must be less than 1mb.",
        }); 
        fileRef.current.value="";
      }
    }

    return (
      <div className={classes.root}>
        <Button variant="outlined" size="small" startIcon={<CloudUploadIcon aria-label="upload photo" />}>
          <label htmlFor="upload-photo-button">Change photo</label>
        </Button>
        <input
          className={classes.input}
          id="upload-photo-button"
          type="file"
          accept="image/png"
          ref={fileRef}
          onChange={(e) => processFile(e.target.files[0])}
        />
      </div>
    );
}

export default connect(null, mapDispatchToProps)(UploadPhotoButton);